import { render } from "./TablaConceptos.vue?vue&type=template&id=2c338d2c&scoped=true"
import script from "./TablaConceptos.vue?vue&type=script&lang=js"
export * from "./TablaConceptos.vue?vue&type=script&lang=js"

import "./TablaConceptos.vue?vue&type=style&index=0&id=2c338d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c338d2c"]])

export default __exports__